import { Container, Header } from '../shared/ui/Page';
import React, { Fragment } from 'react';
import { FAQContainer, FAQSectionHeader, FAQSpoilerContentWrapper } from './FAQStyled';
import { Space } from '@gr-monorepo/common/ui';
import Spoiler from '../shared/Spoiler/Spoiler';
import { FAQData } from './FAQData';
import { useClickStreamContext } from '../shared/ClickStream';

const FAQPage = () => {
  const { logPageEvent } = useClickStreamContext();

  return (
    <Container style={{ minHeight: 'calc(100vh - 71px)', height: '100%' }}>
      <Header>Частые вопросы</Header>
      <Space size={40} axis="vertical" />
      <FAQContainer>
        {FAQData.map((section, index) => (
          <Fragment key={section.sectionName}>
            <FAQSectionHeader>{section.sectionName}</FAQSectionHeader>
            <Space size={24} axis="vertical" />
            {section.queryItems.map((queryItem) => (
              <Fragment key={queryItem.query}>
                <Spoiler
                  summary={queryItem.query}
                  spoilerContent={<FAQSpoilerContentWrapper>{queryItem.answer}</FAQSpoilerContentWrapper>}
                  onChangeState={(isOpen: boolean) => {
                    if (isOpen) {
                      logPageEvent({
                        eventType: `faq_spoiler_opened`,
                        eventInfo: `Частые вопросы|Развернул спойлер с ответом на вопрос`,
                        cd1: 'Раздел: ' + section.sectionName,
                        cd2: 'Вопрос: ' + queryItem.query,
                      });
                    }
                  }}
                />
                <Space size={8} axis="vertical" />
              </Fragment>
            ))}
            {index !== FAQData.length - 1 && <Space size={32} axis="vertical" />}
          </Fragment>
        ))}
      </FAQContainer>
    </Container>
  );
};

export default FAQPage;
